



import { isSupportViewer } from "../../utils/permissionUtils";

export function filterMenu(menuItems: any, allowedPermissions: any, userType?: string) {
    return menuItems
        .map((item: any) => {
            let newItem = { ...item };

            // Recursively filter submenuItems
            if (newItem.submenuItems && newItem.submenuItems.length > 0) {
                newItem.submenuItems = filterMenu(newItem.submenuItems, allowedPermissions, userType);
            }

            // Should this item be kept?
            let hasPermission;
            if (newItem.permissionCode) {
                // If ADMIN, SUBADMIN, or SUPPORT-VIEWER, show all menu items explicitly
                if (userType === 'ADMIN' || userType === 'SUBADMIN' || isSupportViewer(userType)) {
                    hasPermission = true;
                } else {
                    // For SUBADMIN and COs, require the allowedPermissions list to explicitly include it
                    hasPermission = allowedPermissions.length > 0 && allowedPermissions.includes(newItem.permissionCode);
                }
            } else {
                // If no permissionCode, keep by default
                hasPermission = true;
            }

            const hasVisibleSubmenus = newItem.submenuItems && newItem.submenuItems.length > 0;

            if (hasPermission || hasVisibleSubmenus) {
                return newItem;
            }

            // Otherwise, remove it
            return null;
        })
        .filter((item: null) => item !== null);
}


export const maskEmail = (email: string) => {
    if (email) {
        const [local, domain] = email.split('@');
        if (local.length <= 3) {
            return '*'.repeat(local.length) + '@' + domain;
        }
        const visiblePart = local.slice(-3);
        const maskedPart = '*'.repeat(local.length - 3);
        return maskedPart + visiblePart + '@' + domain;
    }
    return '';
}


export const maskPhoneNumber = (phone: string) => {
    if (phone) {
        const phoneStr = phone.toString();
        if (phoneStr.length <= 6) {
            // If phone is too short, just mask all but last 2
            return '*'.repeat(phoneStr.length - 2) + phoneStr.slice(-2);
        }
        const firstTwo = phoneStr.slice(0, 2);
        const lastFour = phoneStr.slice(-4);
        return firstTwo + 'XXXX' + lastFour;
    }
    return '';
}

export const toCamelCase = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const randomAvatar = (firstName: string) => {
    const colors = [
        "#f56a00",
        "#7265e6",
        "#ffbf00",
        "#00a2ae",
        "#87d068",
        "#d46b08",
    ];
    const index = Math.floor(Math.random() * colors.length);
    const initial = firstName?.charAt(0)?.toUpperCase() || "?";
    return {
        bg: colors[index],
        initial,
    };
};